import { offer } from './../voucher-card-secondary/voucher-card-secondary.component';
import { MultiselectPanelComponent } from './../multiselect-panel/multiselect-panel.component';
import { DataTransferService } from './../../services/datatransfer.service';
import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { AuthenticationComponent } from 'src/app/components/authentication/authentication.component';
import { ApiService } from 'src/app/services/api.service';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { ModalWrapperService } from '../modal-wrapper/modal-wrapper.service';
import { VoucherCardSecondaryComponent } from '../voucher-card-secondary/voucher-card-secondary.component';
import { AubGTMTrackingService } from 'src/app/services/aub-gtm-tracking.service';

export type CardContent = {
  code: string;
  description?: string | null;
  name: string;
  logo_url: string;
  [x: string]: any;
};
@Component({
  selector: 'app-poshvine-card-primary',
  styleUrls: ['./card-primary.component.scss'],
  templateUrl: './card-primary.component.html',
})
export class CardPrimaryComponent {
  @Input() cardContent: CardContent = {} as CardContent;
  @Input() size: 'medium' | 'small' = 'medium';
  @Input() flavor: 'rounded' | 'edged' = 'rounded';
  @Input() categoryType: 'generic' | 'nearme' | 'international' = 'generic';
  selectedOffer: any;
  merchantId: string | null = '';
  listOfOffers: any[] = [];
  selectedOfferMerchantDetails: any;
  modalInstance: NgbModalRef | any;
  voucherCardModalInstance: NgbModalRef | any;
  multiOfferModalInstance: NgbModalRef | any;


  constructor(
    private router: Router,
    private modalService: ModalWrapperService,
    private _authService: AuthenticationService,
    private _apiService: ApiService,
    private _dts: DataTransferService,
    private auBankTrackingService: AubGTMTrackingService
  ) {

   }
   ngOnInit(){
     this.loadInitialData();
   }
  offerAction(param: 'claim' | 'knowMore'): void {
    if (param === 'claim') {
      this.claimOffer();
    } else {
      this.navigateToKnowMore();
    }
  }
  claimOffer() {
    if (this._authService.isUserAuthenticated) {
      this.openCouponModal();
    } else {
      this.modalInstance = this.modalService.open(
        AuthenticationComponent,
        'login-modal',true
      );
      this.modalInstance.componentInstance.restartLogin();
      this.modalInstance.componentInstance.closeAuthenticationEvent.subscribe(
        (res: any) => {
          if (res) {
            this.modalInstance.close();
            this._dts.nextReloadEvent(true)
          }
        }
      );
    }
  }

  openCouponModal() {
        this.claimFlowInitialiser();
  }
  async loadMultiClaimFlow(){
    this.multiOfferModalInstance = this.modalService.open(
      MultiselectPanelComponent,'',
      true
    );
    this.multiOfferModalInstance.componentInstance.isContentLoading = true;
    if(this.cardContent?.offer && !this.listOfOffers.length){
     await this.fetchAllOffers().then();
    }
    let panelObject = {
      img:this.cardContent?.logo_url,
      list:(this.cardContent.offers && this.cardContent.offers.data)?this.cardContent.offers?.data:
      (this.listOfOffers)?this.listOfOffers:[],
      title:this.cardContent?.name
    }
    this.multiOfferModalInstance.componentInstance.panelDetails =
    panelObject;
    this.multiOfferModalInstance.componentInstance.isContentLoading = false;
    this.multiOfferModalInstance.componentInstance.btnClickEvent.subscribe(({action,item,index}:any)=>{
      console.log('resp',action,index);
      if(action === 'cancel'){
        this.multiOfferModalInstance.close();
      } else if (action === 'knowmore') {

        this.multiOfferModalInstance.close();
        this.navigateToKnowMore({selectedOfferIndex:index});
      } else if(action === 'claim'){
        this.selectOffer(item);
        // this.selectOffer(resp.data[0]);
        this.loadVoucherFlow();
      }
    })
  }
  loadVoucherFlow() {
    this.auBankTrackingService.aubts_gtm_claim('claim', 
      {
        merchantId: this.selectedOfferMerchantDetails?.id,
        merchantName: this.selectedOfferMerchantDetails?.name,
        offerId: this.selectedOffer?.id
      });
    this.voucherCardModalInstance = this.modalService.open(
      VoucherCardSecondaryComponent,
      'voucher-card-secondary-modal',
      true
    );
    this.voucherCardModalInstance.componentInstance.selectedOffer =
      this.processSelectedOffer(this.selectedOffer);
      this.voucherCardModalInstance.componentInstance.hideEvent.subscribe((resp:any)=>{
        if(resp){
          this.voucherCardModalInstance.close();
        }
      })
    const redemptionHandler =  (res: any) => {
      if (res) {
        // this.modalInstance.hide();
        
        if(this.selectedOffer.attributes.redemption_type !== 'multiple_redemption_allowed'){
          this.selectedOffer.attributes.claimable = false;
          
        }
      }
    }
    this.voucherCardModalInstance.result.then((result:any) => {
      redemptionHandler(true);
    }, (reason:any) => {
      redemptionHandler(true);
    });

  }
  loadInitialData() {
    if(this.cardContent && this.cardContent.offers && this.cardContent.offers
      && this.cardContent.offers.data && this.cardContent.offers.included){
        this.selectedOfferMerchantDetails = JSON.parse(JSON.stringify(this.cardContent));
        if (this.cardContent.offers.data && this.cardContent.offers.data.length
          && this.cardContent.offers.data[0]) {
          this.listOfOffers = this.cardContent.offers.data;
          if(this.cardContent.offers.data.length > 1){
            const indeF = this.cardContent.offers.data.findIndex((e:any)=> e.attributes.claimable);
            if(indeF !== -1){
              this.cardContent.offers.data[0].attributes.claimable = true;
            }
          }
          this.selectOffer(this.cardContent.offers.data[0]);

        }
      } else {
        if(this.cardContent && this.cardContent.offer){
          this.selectedOfferMerchantDetails = JSON.parse(JSON.stringify(this.cardContent));
            this.listOfOffers = [];
            this.selectOffer({ ... this.cardContent.offer,
            attributes:this.cardContent.offer});
        }
        this.merchantId = this.cardContent.merchantId || '';

      }

  }
  fetchAllOffers():Promise<any>{
    return new Promise((res,rej)=>{
      if (this.merchantId) {
        const offerHandler =  (resp:any) => {
          if (resp.data && resp.data.length && resp.data[0]) {
            this.listOfOffers = resp.data;
            res('success');
          }
        }
        if(this.categoryType === 'generic'){
          this._apiService.getOffers({ merchant_id: this.merchantId }).subscribe(offerHandler);
        } else if(this.categoryType === 'international'){
          this._apiService.getOffers({ merchant_id: this.merchantId },false,true).subscribe(offerHandler);
        } else if(this.categoryType === 'nearme'){
          this._apiService.getOffers({ merchant_id: this.merchantId },true).subscribe(offerHandler);
        }
      }
    })

  }

  claimFlowInitialiser() {
    if (this.listOfOffers.length > 1) {
      this.loadMultiClaimFlow();
    } else if (this.listOfOffers.length === 1) {
      this.loadVoucherFlow();
    } else if (this.listOfOffers.length === 0 && this.selectedOfferMerchantDetails
      && this.selectedOfferMerchantDetails.offers_count) {
      this.selectedOfferMerchantDetails.offers_count > 1 ? this.loadMultiClaimFlow() :
        this.loadVoucherFlow();
    }
  }
  selectOffer(offerData: any) {
    this.selectedOffer = { ...offerData, ...offerData.attributes };
    if(this.flavor === 'edged' && (this.selectedOffer.attributes.redemption_type === 'multiple_redemption_allowed' &&
     !this.selectedOffer.attributes.claimable)){
      this.selectedOffer.attributes.claimable = true;
    }
    this.setRelogin();
  }
  setRelogin(){
    if(!this._authService.isUserAuthenticated){
      this.selectedOffer.attributes.claimable = true;
    }
  }
  processSelectedOffer(offer: any) {
    return {
      id: this.cardContent.id,
      merchantLogoUrl: this.cardContent.logo_url,
      offerType: this.selectedOffer.attributes.offer_type,
      endDate: this.selectedOffer.attributes.end_date,
      offerTitle: this.selectedOffer.attributes?.title,
      merchantName: this.cardContent.name,
      merchantId: this.cardContent.id,
      redemptionUrl: this.selectedOffer.attributes.redemption_url
        ? this.selectedOffer.attributes.redemption_url :
        this.selectedOfferMerchantDetails.website,
    };
  }
  processSelectedOfferTerms(offer: any) {
    return {
      terms: this.selectedOffer.attributes.terms,
      merchantName: this.cardContent.name,
      redemptionUrl: this.selectedOffer.attributes.redemption_url
        ? this.selectedOffer.attributes.redemption_url
        : this.selectedOfferMerchantDetails.website,
    };
  }
  navigateToKnowMore(extraParams:{[x:string]:any}={}){
    this.router.navigate(['offers','offer-details', this.cardContent.merchantId, this.categoryType, this.cardContent.name.split(' ').join('-').split(',').join('').split('(').join('').split(')').join('').toLowerCase()], {
      queryParams: { merchantId: this.cardContent.merchantId, categoryType:this.categoryType, ... extraParams },
    });
  }
}
